import styles from './TermsScreen.module.scss';
import common from '../../util/scss/common.module.scss';
import PageLayout from '../../layout/PageLayout/PageLayout';
import GlobalContext from '../../contexts/GlobalContext';
import Card from '../../components/Card/Card';
import { ERoutes, ELinks } from '../../util/constants';
import TermsContext, { ETermsUiState, TermsProvider } from '../../contexts/TermsContext';
import { Redirect } from 'react-router';
import { replaceElement } from '../../util/helpers';
import CardLoader from '../../components/Loader/Loader';
import { FC, useContext, useMemo } from 'react';
import { LoadingButton } from '@mui/lab';
import { Link, Checkbox, FormControlLabel } from '@mui/material';

// tslint:disable: react-a11y-anchors
const TermsAgreement: FC = () => {
    const { language } = useContext(GlobalContext);
    const { submitAgreeToTerms, termsUiState, hasAgreed, setHasAgreed } = useContext(TermsContext);
    const formattedDesc = useMemo(() => {
        const descStart = replaceElement(
            language.agreeToTerms.desc.start,
            'termsLink',
            <Link href={ELinks.termsServiceConsumer} target="_blank" />,
        );
        const descEnd = replaceElement(
            language.agreeToTerms.desc.end,
            'privacyLink',
            <Link href={ELinks.privacyPolicy} target="_blank" />,
        );
        return (
            <>
                {descStart} {descEnd}
            </>
        );
    }, []);

    const toggleAgreement = () => {
        setHasAgreed(!hasAgreed);
    };

    const handleSubmitAgreement = (event) => {
        event.preventDefault();
        submitAgreeToTerms();
    };

    return (
        <Card>
            <header>
                <h1 className={`${common.pageHeader} ${common.withSubhead}`} data-testid="screen-title">
                    {language.agreeToTerms.title}
                </h1>
                <h2 className={`${common.pageSubhead} ${styles.desc}`} data-testid={'terms-desc'}>
                    {formattedDesc}
                </h2>
            </header>
            <section className={styles.agreement}>
                <FormControlLabel
                    label={language.agreeToTerms.label}
                    control={<Checkbox checked={hasAgreed} onChange={toggleAgreement} />}
                />
            </section>
            <section className={styles.cta}>
                <LoadingButton
                    variant="contained"
                    type="submit"
                    disabled={!hasAgreed || termsUiState === ETermsUiState.loading}
                    loading={termsUiState === ETermsUiState.loading}
                    onClick={handleSubmitAgreement}
                    size="large"
                >
                    {language.agreeToTerms.cta}
                </LoadingButton>
            </section>
        </Card>
    );
};

const TermsUi: FC = () => {
    const { termsUiState, redirectUrl } = useContext(TermsContext);

    let termsUi: React.ReactElement;
    switch (termsUiState) {
        case ETermsUiState.default:
        case ETermsUiState.routerStateParsed:
            termsUi = <CardLoader />;
            break;
        case ETermsUiState.loading:
        case ETermsUiState.ready:
            termsUi = <TermsAgreement />;
            break;
        case ETermsUiState.success:
            termsUi = (
                <>
                    <CardLoader />
                    {window.location.assign(redirectUrl)}
                </>
            );
            break;
        case ETermsUiState.error:
            termsUi = <Redirect to={ERoutes.error} />;
            break;
        default:
            throw Error('TermsUiState set incorrectly');
    }

    return termsUi;
};

const TermsScreen: FC = () => {
    return (
        <TermsProvider>
            <PageLayout>
                <TermsUi />
            </PageLayout>
        </TermsProvider>
    );
};

export default TermsScreen;
